<template>
  <div class="uploader" :class="className">
    <el-upload ref="uploaderImage" class="uploader-image" action="" accept="image/*" :show-file-list="false" :on-change="handlePushUploader" :auto-upload="false" :disabled="disabled">
      <div v-if="url" style="width: 100%;height: 100%;">
        <img :src="url" class="uploader-img uploader-push">
        <div v-if="showReplace" class="link-color" style="margin-top:10px;font-size:14px;">更换图片</div>
      </div>
      <i v-else class="el-icon-plus plus-push" />
    </el-upload>
    <div v-if="title" class="tip">{{ title }}</div>
    <p class="uploader-info" :style=" title == '' && url == '' ? 'margin-top:10px' : '' ">支持上传*.png、*.jpg</p>
    <p class="uploader-info">大小不超过{{ limitSize }}M</p>
    <p v-if="sizeTips" class="uploader-info">尺寸：{{ sizeTips }}</p>
    <p v-if="breadth" class="uploader-info">宽度：{{ breadth }}, 高度不限</p>
  </div>
</template>

<script>
import { getFileType } from '@/common/js/util';

export default {
  name: 'UpdateImage',
  props: {
    className: {
      type: String,
      default: '',
    },
    showReplace: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    sizeTips: {
      type: String,
      default: '',
    },
    breadth: {
      type: String,
      default: '',
    },
    limitSize: {
      type: Number,
      default: 5,
    },
    savePath: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    handlePushUploader(file) {
      this.uploader(file);
    },
    uploader(file) {
      if (getFileType(file.raw.name) !== 'image') {
        this.$message.error('图片格式不正确');
        this.$refs.uploaderImage.clearFiles();
        return;
      }
      if (this.limitSize && parseFloat(file.raw.size / 1024 / 1024) > this.limitSize) {
        this.$message.error(`图片大小不能超过${this.limitSize}M`);
        this.$refs.uploaderImage.clearFiles();
        return;
      }
      this.sizeTips || this.breadth ? this.asyncImgChecked(file).then(data => {
        if (data) {
          this.$Api.uploadFile.uploadImage(file.raw, this.savePath).then(data => {
            this.uploadLoading = false;
            this.$emit('upload', data);
            this.$emit('triggerReg', file);
          });
        } else {
          return;
        }
      }) : this.$Api.uploadFile.uploadImage(file.raw, this.savePath).then(data => {
        this.uploadLoading = false;
        this.$emit('upload', data);
        this.$emit('triggerReg', file);
      });
    },
    asyncImgChecked(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.raw); // 必须用file.raw
        reader.onload = () => { // 让页面中的img标签的src指向读取的路径
          const img = new Image();
          img.src = reader.result;
          if (this.sizeTips) {
            const width = this.sizeTips.split('*')[0];
            const height = this.sizeTips.split('*')[1];
            img.onload = () => {
              if (img.width !== parseInt(width) || img.height !== parseInt(height)) {
                this.$message.warning(`图片大小不匹配，当前文件${img.width}×${img.height}`);
                resolve(false);
              } else {
                resolve(true);
              }
            };
          } else if (this.breadth) {
            const width = this.breadth.split('*')[0];
            img.onload = () => {
              if (img.width !== parseInt(width)) {
                this.$message.warning(`图片大小不匹配，当前文件${img.width}×${img.height}`);
                resolve(false);
              } else {
                resolve(true);
              }
            };
          }
        };
      });
    },
  },
};
</script>

<style lang="less" >
.uploader {
  margin-right: 30px;

  white-space: nowrap;

  .uploader-image {
    height: auto;

    .el-upload {
      position: relative;

      width: 150px;
      height: 150px;

      cursor: pointer;
      text-align: left;

      color: #bbbbbb;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      background: #f7f7f7;
      // overflow: hidden;

      font-size: 12px;
      line-height: 20px;
    }

    .el-upload:hover {
      border-color: #c1c1c1;
    }

    .el-icon-plus {
      width: 150px;
      height: 150px;

      text-align: center;

      color: #8c939d;

      font-size: 32px;
      line-height: 150px;
    }
    .uploader-img {
      // width: 150px;
      // height: 150px;
      display: block;

      width: 100%;
      height: 100%;

      object-fit: contain;
    }
  }
  .uploader-info {
    color: #bbbbbb;

    font-size: 12px;
    line-height: 18px;
  }
}
</style>
